import { getUserFactoryId } from '../../..';
import api from '../../services/api'; 

export async function getStructure(id){
	let retorno = await api.get(`/structure/odata?$select=status,name,code,stepTpm,typeId,fatherId,&$filter=id+eq+${id}`).catch(e=>{
		return e;
	});

	if(retorno.status == 200){
		return retorno.data.value[0];
	}else{
		return {};
	}
};

export async function postStructure(body){
	let retorno = await api.post(`/structure`, body).catch(e=>{
		return e;
	});

	if(retorno.status == 200){
		return true;
	}else{
		return false;
	}
};

export async function putStructure(body){
	let retorno = await api.put(`/structure`, body).catch(e=>{
		return e;
	});

	if(retorno.status == 200){
		return true;
	}else{
		return false;
	}
};